import { PureComponent } from 'react'

class ThrowError extends PureComponent {
    componentWillMount() {
        throw new Error('Testing error boundary')
    }

    render() {
        return false
    }
}

export default ThrowError
